<script>
export default {
  name: "UiCompletionStepper",
  props: {
    steps: {
      type: Number,
      default: 3,
    },
    current: {
      type: Number,
      default: 1,
    },
    status: {
      type: String,
      default: "danger",
      validation: (value) => {
        return ["success", "warning", "danger", "info"].includes(value)
      },
    },
  },
  computed: {
    statusClass() {
      return `bg-${this.status}`
    },
  }
}
</script>

<template>
  <div 
    data-comp="UiCompletionStepper"
    class="d-inline-flex rounded-lg overflow-hidden"
  >
    <div 
      v-for="n in steps"
      :key="n" 
      data-part="step"
      :class="[n <= current ? statusClass : 'bg-gray-200']" 
      class="flex-grow-1"
    ></div>
  </div>
</template>

<style scoped lang="scss">
[data-comp="UiCompletionStepper"] {
  height: 6px;
  min-width: 12em;
  gap: 2px;
}
</style>
